import { EditorialFactoryProps } from "components/flexComponents/Editorial/typings";
import CardWithLinkEditorial from "components/flexComponents/Editorial/factory/impl/editorials/CardWithLinkEditorial";

export class FullBleedVerticalCard extends CardWithLinkEditorial {
  /* istanbul ignore next */
  constructor(editorial: EditorialFactoryProps) {
    super(editorial);
  }

  public getEditorialItemClassName = (): string => "fullBleedVerticalCard all-y-gutter-three";
}

export default FullBleedVerticalCard;
